module.exports = {
	name: 'Octopharma - Mirta web app',
	shortName: 'Mirta',
	description: 'Octopharma portal version of the mobile app',
	primaryColor: '#02855b',
	secondaryColor: '#13a689',
	msTileColor: '#02855b'
}

// rama pharma config
// module.exports = {
// 	name: 'Rama Pharma - Rama Pharma web app',
// 	shortName: 'Rama Pharma',
// 	description: 'Rama Pharma portal version of the mobile app',
// 	primaryColor: '#004a98',
// 	secondaryColor: '#f57f20',
// 	msTileColor: '#004a98'
// }

// right
// module.exports = {
// 	name: 'Octopharma - Right web app',
// 	shortName: 'Right',
// 	description: 'Octopharma portal version of the mobile app',
// 	primaryColor: '#02855b',
// 	secondaryColor: '#13a689',
// 	msTileColor: '#02855b'
// }